<template>
  <div>
    <MainMenu ref="compMainMenu" />
    <v-main class="py-0">
      <MainSearch ref="compMainSearch" @activeSearch="activeSearch = true" />
      <v-layout row wrap justify-space-between px-4>
        <p v-if="!activeSearch" class="pt-5 pl-3 blue--text subtitle-1">
          <v-icon class="pb-1" color="blue">stars</v-icon>
          Imóveis em destaque
        </p>
        <p v-else class="pt-5 pl-3 black--text subtitle-1">
          <v-icon class="pb-1">search</v-icon>
          Resultado da pesquisa:
          <v-chip
            small
            label
            color="green"
            text-color="white"
            close
            @click:close="cleanFilterSearch()"
          >
            Ativado
          </v-chip>
        </p>
        <div class="d-flex justify-end pt-2">
          <v-btn
            elevation="0"
            outlined
            small
            class="text-capitalize"
            @click="sendSearchToServer()"
          >
            Pesquisar
          </v-btn>
        </div>
      </v-layout>
      <v-layout justify-start>
        <v-sheet min-height="600" color="transparent" class="pl-6">
          <v-layout row wrap justify-space-around py-2>
            <p v-if="immobileList.length <= 0 && !immobileApiLoading" class="pt-5 pl-3 black--text subtitle-1">
              Nenhum imóvel foi encontrado
              <v-icon class="pb-1" color="blue">sentiment_dissatisfied</v-icon>
            </p>
            <v-flex else class="py-2" v-for="(item) in immobileList" :key="item.id" xs12 ms12 md4 lg3 xl2>
              <v-list-item :to="'/informacoes_imovel#' + item.id">
                <ImmobileCard :immobileInfo="item" />
              </v-list-item>
            </v-flex>
          </v-layout>
        </v-sheet>
      </v-layout>
    </v-main>
    <v-spacer class="pt-10"></v-spacer>
    <BottomBar />
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import apiState from '@/ilios.store'
import MainMenu from '@/components/Global/MainMenu.vue'
import MainSearch from '@/components/Global/MainSearch.vue'
import ImmobileCard from '@/components/Global/ImmobileCard.vue'
import BottomBar from '@/components/Global/BottomBar.vue'

export default {
  name: 'HomeScreen',

  components: {
    MainMenu,
    MainSearch,
    ImmobileCard,
    BottomBar,
  },

  data: () => ({
    activeSearch: false,
    immobileNotFound: false,
  }),

  mounted() {
    this.cleanImmobileList()
    if(this.getBuyMenuId() == null && this.getRentMenuId() == null){
      this.setImmobilesList({
        domain: "[('publicar_imovel', '=', 1), ('destacar_imovel', '=', 1)]"
      })
    }
  },

  computed: {
    immobileList(){
      return this.getImmobilesList()
    },

    immobileApiLoading(){
      return this.getImmobileApiState() === apiState.LOADING
    },
  },

  watch: {

  },

  methods: {
    
    ...mapActions({
      setImmobilesList: 'Immobile/getImmobilesList',
      cleanImmobileList: 'Immobile/cleanImmobileList',
      cleanBuyMenuId: 'Immobile/cleanBuyMenuId',
      cleanRentMenuId: 'Immobile/cleanRentMenuId',
    }),

    ...mapGetters({
      getImmobilesList: 'Immobile/getImmobilesList',
      getImmobileApiState: 'Immobile/getApiState',
      getBuyMenuId: 'Immobile/getBuyMenuId',
      getRentMenuId: 'Immobile/getRentMenuId',
    }),

    async cleanFilterSearch(){
      await this.cleanImmobileList()
      await this.cleanBuyMenuId()
      await this.cleanRentMenuId()
      await this.setImmobilesList({
        domain: "[('publicar_imovel', '=', 1), ('destacar_imovel', '=', 1)]"
      })
      this.activeSearch = false
      this.$refs.compMainSearch.cleanSearchFields()
    },

    sendSearchToServer(){
      this.$refs.compMainSearch.sendSearchToServer()
    }

  },
};
</script>